<button
  libButton
  variant="ghost"
  size="sm"
  type="button"
  class="min-w-0 px-3"
  [attr.aria-expanded]="isOpen()"
  aria-haspopup="listbox"
  [attr.aria-controls]="isOpen() ? listboxId : null"
  aria-label="Select language"
  (click)="toggle($event)">
  <span>{{ currentLanguage().shortName }}</span>
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    class="size-4 shrink-0 transition-transform duration-200"
    [class.rotate-180]="isOpen()">
    <path
      d="M8 10l4 4 4-4"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</button>

@if (isOpen()) {
  <ul
    [id]="listboxId"
    role="listbox"
    aria-label="Languages"
    class="language-selector__menu space-y-1 absolute right-0 top-[calc(100%+0.5rem)] w-min rounded-2xl bg-white p-2 shadow-ui-control">
    @for (language of languages(); track language.code) {
      <li role="none" class="w-full">
        <button
          type="button"
          role="option"
          class="language-selector__option flex items-center gap-2 rounded-full px-3 py-2 text-left text-sm whitespace-nowrap text-ui-outline-foreground transition-colors hover:bg-ui-primary/10"
          [class.bg-ui-primary/50]="isSelected(language.code)"
          [attr.aria-selected]="isSelected(language.code)"
          (click)="selectLanguage(language.code, $event)">
          <img
            [src]="language.flagSrc"
            alt=""
            width="20"
            height="14"
            class="h-3.5 w-5 shrink-0 rounded-sm object-cover" />
          <span [attr.lang]="language.code">{{ language.name }}</span>
        </button>
      </li>
    }
  </ul>
}
